import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, UntypedFormControl} from '@angular/forms';
import {
  StateCountry,
  Carrier,
  RatesSroMaster,
  FrtRatesBidcycles
} from 'src/app/shared/common-components/common-structure';
import {TransportationType as TT} from 'src/app/shared/common-components/AppConstants';
import {HhgRateEditService} from 'src/app/services/hhg-rate-edit/hhg-rate-edit.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {HhgRatesCsvDownloadService} from 'src/app/services/hhg-rates-csv-download/hhg-rates-csv-download.service';
import {FrtRatesBidcyclesService} from 'src/app/services/frt-rates-bidcycles/frt-rates-bidcycles.service';
import {ControlKeys} from '../ratefile-open/control-keys';
import {CarrierService} from 'src/app/services/carrier/carrier.service';
import {HhgRatesCsvDownload} from './hhgRatesCsvDownload';
import * as _ from 'lodash';
import {DownloadFileResponse} from 'src/app/shared/common-components/file-storage/downloadFileResponse';
import * as FileSaver from 'file-saver';
import {api_error, hhg_download_success} from '../../shared/common-components/AppConstants';
import {StateCountryService} from 'src/app/services/state-country/state-country.service';
import {map, shareReplay, combineLatest} from 'rxjs/operators';
import {merge, forkJoin} from 'rxjs';

@Component({
    selector: 'app-hhg-rates-csv-download',
    templateUrl: './hhg-rates-csv-download.component.html',
    styleUrls: ['./hhg-rates-csv-download.component.css'],
    standalone: false
})
export class HhgRatesCsvDownloadComponent implements OnInit {

  hhgCsvDownloadForm: UntypedFormGroup;
  effectiveDatesList: ControlKeys[];
  ratesBidcyclesList: FrtRatesBidcycles[];
  carrierList: Carrier[];
  sroList: RatesSroMaster[];
  origStateList: StateCountry[];
  destStateList: StateCountry[];
  stateCountryVar: string;
  allRateTypeValueList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 11, 12, 13, 14, 15];
  generalRateTypeValueList: number[] = [1, 2, 5, 6, 11, 12, 13];
  moveMgmtRateTypeValueList: number[] = [3, 4, 7, 8, 14, 15];
  rateTypeList: any[];
  transportationList: any[];
  rateOnTransType: any[];

  controlId: string;
  ratesBidcyclesId: number;
  rateExpiryDate: Date;
  rateTypes: Number[];
  carrierId: string[];
  sroMasterIdList: string[];
  originId: string;
  destinationId: string;
  transType: any[];
  hhgRatesCsvDownload: HhgRatesCsvDownload;
  tempTransType: String;
  tempRateType: String;


  private tmssloader;
  showExport = false;
  controlChanged = false;
  rateTypeChanged = false;
  scacChanged = false;
  sroChanged = false;
  originChanged = false;
  destinationChanged = false;
  transportationChanged = false;
  allCarriersSelected: any;
  testAllDest = true;

  stateCountries$ = this.stateCountryService.getAll().pipe(map(results => results.sort(
    (x, y) => x.stateCountryName < y.stateCountryName ? -1 : 1)), shareReplay(1));

  statesAndCountries1$ = this.stateCountries$.pipe(map(
    (results) => results.filter(state => state.stateCountryType === 'Country' ||
      state.stateCountryType === 'State')
      .filter(state => state.stateCountryCode !== 'US00')
      .filter(state => state.stateCountryCode !== 'CA00')
      .filter(state => state.stateCountryCode !== 'HI')
      .filter(state => state.stateCountryCode !== 'AK')
      .filter(state => state.stateCountryCode !== 'PR')
      .filter(state => state.stateCountryCode !== 'LB')
      .filter(state => state.stateCountryCode !== 'NF')), shareReplay(1));

  allList$ = this.stateCountries$;
  usStates$ = this.stateCountries$.pipe(map(
    (results) => results.filter(state => (state.stateCountryType === 'State') &&
      (state.parentCountryId === 326))
      .filter(state => state.stateCountryCode !== 'HI')
      .filter(state => state.stateCountryCode !== 'AK')
      .filter(state => state.stateCountryCode !== 'PR')), shareReplay(1));

  states$ = this.stateCountries$.pipe(map(
    (results) => results.filter(state => state.stateCountryType === 'State')
      .filter(state => state.stateCountryCode !== 'HI')
      .filter(state => state.stateCountryCode !== 'AK')
      .filter(state => state.stateCountryCode !== 'PR')
      .filter(state => state.stateCountryCode !== 'LB')
      .filter(state => state.stateCountryCode !== 'NF')), shareReplay(1));

  serviceAreas$ = this.stateCountries$.pipe(map(
      (results) => results.filter(state => state.stateCountryType === 'Service Area')
        .filter(state => state.stateCountryCode !== '0000')
        .filter(state => state.stateCountryCode !== '2302')
        .filter(state => state.stateCountryCode !== '2305')
        .sort((x, y) => x.stateCountryCode < y.stateCountryCode ? -1 : 1)),
    shareReplay(1));

  countries$ = this.stateCountries$.pipe(map(
    (results) => results.filter(state => state.stateCountryType === 'Country')
      .filter(state => state.stateCountryCode !== 'US00')
      .filter(state => state.stateCountryCode !== 'CA00')), shareReplay(1));

  statesAndCountries$ = forkJoin(this.states$, this.countries$).pipe(
    map(([states, countries]) => states.concat(countries)), shareReplay(1));


  allDest$ = forkJoin(this.statesAndCountries$, this.serviceAreas$).pipe(
    map(([statesAndCountries, serviceAreas]) => statesAndCountries.concat(serviceAreas)),
    shareReplay(1));

  domesticOrig$ = this.stateCountries$.pipe(map(
      (results) => results.filter(state => (state.stateCountryType === 'State'))
        .filter(state => state.stateCountryCode !== 'HI')
        .filter(state => state.stateCountryCode !== 'AK')
        .filter(state => state.stateCountryCode !== 'PR')),
    shareReplay(1));

  domesticDest$ = forkJoin(this.states$, this.serviceAreas$).pipe(
    map(([states, serviceAreas]) => states.concat(serviceAreas)), shareReplay(1));

  origin$: any;
  destination$: any;
  allTranFlag: boolean;
  allScacFlag: boolean;
  allOrigFlag: boolean;
  allDestFlag: boolean;
  allOrigDestFlag: boolean;
  allTranScacFlag: boolean;

  constructor(private fb: UntypedFormBuilder,
              private hhgRateEditService: HhgRateEditService,
              private hhgRatesCsvDownloadService: HhgRatesCsvDownloadService,
              private frtRateBidcyclesService: FrtRatesBidcyclesService,
              private carrierService: CarrierService,
              public loader: LoadingService,
              private alertService: AlertService,
              private stateCountryService: StateCountryService,
              private modalService: BsModalService) {

  }

  ngOnInit() {
    this.createForm();
    this.tmssloader = this.loader;
    this.populateEffectiveDatesDropdown();
    this.populateRateType();
    this.populateCarrierDropdown();
    this.populateSroDropdown();
    this.populateOriginDropdown();
    this.populateDestinationDropdown();
    this.populateTransportationList();
  }

  createForm() {
    this.hhgCsvDownloadForm = this.fb.group({
      effectiveDates: new UntypedFormControl(''),
      rateType: new UntypedFormControl(''),
      scac: new UntypedFormControl(''),
      sro: new UntypedFormControl(''),
      origin: new UntypedFormControl(''),
      destination: new UntypedFormControl(''),
      transType: new UntypedFormControl('')
    });
  }

  populateEffectiveDatesDropdown() {
    this.tmssloader.show();
    //this.hhgRatesCsvDownloadService.getEffectiveDates("HHG Rate Effective Dates").subscribe(allDates => {
    this.frtRateBidcyclesService.getRatesBidCyclesByBusinessTypes("HHG").subscribe(allRateCycles => {
      this.ratesBidcyclesList = allRateCycles;
      //this.effectiveDatesList = allDates;
      this.tmssloader.hide();
      this.populateSroDropdownFiltered();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving Effective Dates List');
    });
    this.controlChanged = false;
  }

  populateTransportationList() {
    this.transportationList = new Array();
    this.transportationList = [
      {"Text": "All", "Value": [TT.DOMESTIC, TT.INTERNATIONAL]},
      {"Text": "Domestic", "Value": [TT.DOMESTIC]},
      {"Text": "International", "Value": [TT.INTERNATIONAL]},
      {"Text": "Extended Storage", "Value": [TT.EXTENDEDSTORAGE]}];
    this.allTranFlag = false;
  }

  populateRateType() {
    this.rateTypeList = new Array();
    this.rateTypeList = [{"Text": "All", "Value": this.allRateTypeValueList},
      {"Text": "General", "Value": this.generalRateTypeValueList},
      {"Text": "Move Management", "Value": this.moveMgmtRateTypeValueList}];
    //this.rateTypeList[0] ={"Text" :"General" , "Value" : [1,2,5,6,11,12,13]};
    //this.rateTypeList[1] = {"Text" :"Move Management", "Value" :[3,4,7,8,14,15]};
  }

  populateCarrierDropdown() {
    this.tmssloader.show();
    this.carrierService.getAllCarrierListByBusinessType('HHG').subscribe(carrierList => {
      this.carrierList = carrierList;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving TSP List');
    });
    this.scacChanged = false;
    this.allScacFlag = false;
  }

  populateSroDropdown() {
    this.tmssloader.show();
    this.hhgRatesCsvDownloadService.getSros("HHG").subscribe(allSros => {
      this.sroList = _.sortBy(allSros, (o) => {
        return o.sroId;
      });
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving Sro List');
    });
    this.sroChanged = false;
  }

  populateSroDropdownFiltered() {
    console.log('populateSroDropdownFiltered called', 'ratesBidcyclesList:', this.ratesBidcyclesList, 'ratesBidcyclesId:', this.ratesBidcyclesId);
    if (!this.ratesBidcyclesList || this.ratesBidcyclesList.length === 0) {
      console.log('No ratesBidcyclesList');
      return;
    }
    const selectedBidCycle = this.ratesBidcyclesList.find(bc => bc.ratesBidcyclesId === this.ratesBidcyclesId);
    console.log('selectedBidCycle:', selectedBidCycle);
    if (!selectedBidCycle) {
      console.log('No selectedBidCycle found');
      return;
    }
    this.hhgRatesCsvDownloadService.getSros("HHG").subscribe(allSros => {
      console.log('getSros response:', allSros);
      const rateEffectiveDate = new Date(selectedBidCycle.rateEffectiveDate);
      const rateExpiryDate = new Date(selectedBidCycle.rateExpiryDate);
      this.rateExpiryDate = selectedBidCycle.rateExpiryDate;
      this.sroList = _.sortBy(allSros.filter(sro => {
        if (sro.expiryDate === null) {
          return new Date(sro.effectiveDate) <= rateExpiryDate;
        }
        const sroExpiryDate = new Date(sro.expiryDate);
        return sroExpiryDate >= rateEffectiveDate;
      }), (o) => {
        return o.sroId;
      });
      console.log('Filtered SRO List:', this.sroList);
    }, error => {
      console.error('Error retrieving SRO List:', error);
      this.alertService.error('There was an error retrieving Sro List');
    });
  }

  populateOriginDropdown() {
    this.tmssloader.show();
    this.stateCountryVar = 'stateAndCountry';
    this.hhgRateEditService.getStateCountry(this.stateCountryVar).subscribe(allState => {
      this.origStateList = allState;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving State List');
    });
    this.originChanged = false;
    this.allOrigFlag = false;
    this.hhgCsvDownloadForm.get('destination').disable();
  }

  populateDestinationDropdown() {
    this.tmssloader.show();
    this.stateCountryVar = 'stateAndCountryAndServiceArea';
    this.hhgRateEditService.getStateCountry(this.stateCountryVar).subscribe(allState => {
      this.destStateList = allState;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving State List');
    });
    this.destinationChanged = false;
    this.allDestFlag = false;
  }

  transportationTypeChange() {
    const transTypeSelected = this.hhgCsvDownloadForm.controls.transType.value;
    this.transType = transTypeSelected.Value;
    this.tempTransType = transTypeSelected.Text;
    this.allTranFlag = false;
    if (this.originChanged)
      this.hhgCsvDownloadForm.get('destination').enable();
    if (!_.isEmpty(this.rateTypes)) {
      this.updateRateType();
    }
    this.transportationChanged = true;
    if (this.tempTransType === 'All') {
      this.origin$ = this.statesAndCountries1$;
      this.destination$ = this.allDest$;
      this.allTranFlag = true;
    } else if (this.tempTransType === 'Domestic') {
      this.origin$ = this.domesticOrig$;
      this.setDomesticDestinationOptions(this.hhgCsvDownloadForm.controls.origin.value);
    } else if (this.tempTransType === 'International') {
      this.origin$ = this.statesAndCountries1$;
      this.destination$ = this.statesAndCountries1$;
      this.allTranFlag = true;
    } else if (this.tempTransType === 'Extended Storage') {
      this.origin$ = this.domesticOrig$;
      this.hhgCsvDownloadForm.get('destination').disable();
      this.destination$ = this.domesticDest$;
    }
    this.updateAllFlag();
  }


  effectiveDatesChange(ratesBidcyclesId: any) {
    this.ratesBidcyclesId = +ratesBidcyclesId;
    this.controlChanged = true;
    console.log('Effective Date Changed:', this.ratesBidcyclesId);
    this.populateSroDropdownFiltered();
  }

  rateTypeChange() {
    const rateTypeSelected = this.hhgCsvDownloadForm.controls.rateType.value;
    console.log(rateTypeSelected);
    this.rateTypes = rateTypeSelected.Value;
    this.tempRateType = rateTypeSelected.Text;
    if (!_.isEmpty(this.transType)) {
      this.updateRateType();
    }
    this.rateTypeChanged = true;
  }

  scacChange(carrierId: any[]) {
    this.allCarriersSelected = 0;
    this.carrierId = (JSON.parse(JSON.stringify(this.hhgCsvDownloadForm.value)).scac);
    this.scacChanged = true;
    this.allScacFlag = false;
    if (this.carrierId[0] === '-1') {
      this.allCarriersSelected = 1;
    }
    if (this.carrierId.length > 10 || this.carrierId[0] === '-1') {
      this.allScacFlag = true;
    }
    this.updateAllFlag();
    /* if (this.carrierId.length > 10) {
       this.alertService.error("The maximum number of SCACs allowed to select is 10");
       this.scacChanged = false;
     } else {
       this.scacChanged = true;
     }*/
  }

  sroChange(sroMasterIdList: any[]) {
    this.sroMasterIdList = (JSON.parse(JSON.stringify(this.hhgCsvDownloadForm.value)).sro);
    if (this.sroMasterIdList.indexOf('0') != -1) {
      if (this.sroMasterIdList.length > 1) {
        this.alertService.error("Remove other SROs when selecting All SROs")
        this.sroChanged = false;
      } else {
        this.sroChanged = true;
      }
    } else {
      this.sroChanged = true;
    }
  }

  originChange(originId: any) {
    this.originId = originId;
    this.originChanged = true;
    if (this.tempTransType === 'Domestic') {
      this.setDomesticDestinationOptions(originId);
    }
    let originType;
    if (this.tempTransType === 'International') {
      this.stateCountries$.pipe(map((results) => results.filter((state => state.stateCountryId == +this.originId))))
        .subscribe(res => {
          originType = res[0].stateCountryType
        });
      if (originType === 'State') {
        this.destination$ = this.countries$;
      }
    }

    if (this.tempTransType !== 'Extended Storage') {
      this.hhgCsvDownloadForm.get('destination').enable();
    } else {
      this.hhgCsvDownloadForm.get('destination').disable();
      this.destinationId = '0';
      this.allDestFlag = true;
      this.destinationChanged = true;
    }

    originId == 0 ? this.allOrigFlag = true : this.allOrigFlag = false;
    this.updateAllFlag();
  }

  private setDomesticDestinationOptions(originId: any) {
    const selectedOriginId = +originId;

    if (!selectedOriginId) {
      this.destination$ = this.domesticDest$;
      return;
    }

    this.destination$ = forkJoin(this.domesticOrig$, this.serviceAreas$).pipe(
      map(([domesticOrigins, serviceAreas]) => {
        const selectedOrigin = domesticOrigins.find((origin) => origin.stateCountryId === selectedOriginId);
        return selectedOrigin ? [selectedOrigin, ...serviceAreas] : serviceAreas;
      }),
      shareReplay(1)
    );
  }

  destinationChange(destinationId: any) {
    this.destinationId = destinationId;
    this.destinationChanged = true;
    destinationId == 0 ? this.allDestFlag = true : this.allDestFlag = false;
    this.updateAllFlag();
  }

  buildData() {
    this.hhgRatesCsvDownload = new HhgRatesCsvDownload();

    this.hhgRatesCsvDownload.carrierId = this.carrierId;
    this.hhgRatesCsvDownload.controlId = this.controlId;
    this.hhgRatesCsvDownload.rateTypes = this.rateTypes
    this.hhgRatesCsvDownload.sroMasterIdList = this.sroMasterIdList;
    this.hhgRatesCsvDownload.originId = this.originId;
    this.hhgRatesCsvDownload.destinationId = this.destinationId;
    this.hhgRatesCsvDownload.ratesBidcyclesId = this.ratesBidcyclesId;
    this.hhgRatesCsvDownload.transportationType = this.transType;
    this.hhgRatesCsvDownload.allCarriersSelected = this.allCarriersSelected;

  }

  updateRateType() {
    switch (this.tempTransType) {
      case "All":
        this.rateTypes = (this.tempRateType === "General") ?
          [1, 2, 5, 6, 12, 13] : (this.tempRateType === "Move Management") ?
            [3, 4, 7, 8, 14, 15] : this.allRateTypeValueList;
        break;
      case TT.DOMESTIC:
        this.rateTypes = (this.tempRateType === "General") ?
          [1, 2, 12, 13] : (this.tempRateType === "Move Management") ?
            [3, 4, 14, 15] : [1, 2, 3, 4, 12, 13, 14, 15];
        break;
      case TT.INTERNATIONAL:
        this.rateTypes = (this.tempRateType === "General") ?
          [5, 6] : (this.tempRateType === "Move Management") ?
            [7, 8] : [5, 6, 7, 8];
        break;
      case TT.EXTENDEDSTORAGE:
        this.rateTypes = [11];
        break;
      default:
        break;
    }
  }

  updateAllFlag() {
    this.allOrigDestFlag = (this.allScacFlag && this.allTranFlag) &&
      (this.allOrigFlag && this.allDestFlag);
    this.allTranScacFlag = this.allScacFlag && this.allTranFlag;
    // this.allOrigDestFlag = false;
  }

  /*
  download(){
    let hhgRatesResult: DownloadFileResponse;
    this.tmssloader.show();
    this.buildData();
    console.log(this.hhgRatesCsvDownload);
    this.hhgRatesCsvDownloadService.exportDataFromServer(this.hhgRatesCsvDownload).subscribe(
     (data: any) => {
      hhgRatesResult = data as DownloadFileResponse;
      const byteData: number[] = hhgRatesResult.byteData;
      const fileName: string = hhgRatesResult.fileName;
      const numRows: number = hhgRatesResult.numberOfExcelRows;
      const bytes = new Uint8Array(byteData);
      const blob = new Blob([bytes], {
        type: null
      });
      console.log("data:" + byteData.length);
      //current header length in the csv file is 189. If there are any records in the excel
      //the length will be > 189
      if(byteData.length > 189){
        FileSaver.saveAs(blob, fileName);
        this.alertService.success(hhg_download_success);
      }
      else{
        this.alertService.success("No records found for selected options");
      }
      this.showExport = false;
      this.tmssloader.hide();
      setTimeout(() => {
        this.showExport = true;
      }, 5200);
    }, error => {
      this.alertService.error(api_error);
      this.tmssloader.hide();
    });
  }*/

  download() {
    this.buildData();
    this.tmssloader.show();
    this.hhgRatesCsvDownloadService.exportDataFromServer(this.hhgRatesCsvDownload).subscribe(
      response => {
        this.alertService.success2("Your request has been received. You will be notified via email once the file is ready to be viewed/downloaded.");
        this.tmssloader.hide();
      }
      , error => {
        this.alertService.error("Due to the number of rate offers accepted for one or more of the selected SCACs, the Excel row size limitation of 1,048,575 has been exceeded.  Please adjust your query parameters (choose different SCACs or reduce the number of SCACs and/or SROs).");
        this.tmssloader.hide();
      });
    // this.alertService.success2("Your request has been received. You will be notified via email once the file is ready to be viewed/downloaded.");
  }

  download2() {
    this.buildData();
    this.tmssloader.show();
    this.hhgRatesCsvDownloadService.exportDataFromServer2(this.hhgRatesCsvDownload).subscribe(
      response => {
        this.alertService.success2("Your request has been received. You will be notified via email once the file is ready to be viewed/downloaded.");
        this.tmssloader.hide();
      }
      , error => {
        this.alertService.error("Due to the number of rate offers accepted for one or more of the selected SCACs, the Excel row size limitation of 1,048,575 has been exceeded.  Please adjust your query parameters (choose different SCACs or reduce the number of SCACs and/or SROs).");
        this.tmssloader.hide();
      });
    // this.alertService.success2("Your request has been received. You will be notified via email once the file is ready to be viewed/downloaded.");
  }

  downloadMultiThread() {
    this.buildData();
    this.tmssloader.show();
    this.hhgRatesCsvDownloadService.exportDataFromServerMultiThread(this.hhgRatesCsvDownload).subscribe(
      response => {
        this.alertService.success2("Your request has been received. You will be notified via email once the file is ready to be viewed/downloaded.");
        this.tmssloader.hide();
      }
      , error => {
        this.alertService.error("Due to the number of rate offers accepted for one or more of the selected SCACs, the Excel row size limitation of 1,048,575 has been exceeded.  Please adjust your query parameters (choose different SCACs or reduce the number of SCACs and/or SROs).");
        this.tmssloader.hide();
      });
    // this.alertService.success2("Your request has been received. You will be notified via email once the file is ready to be viewed/downloaded.");
  }

}
